import { createContext } from 'react';

const CoreTableSyncContext = createContext({});
const CoreTableContext = createContext({});

export { CoreTableSyncContext };

export default CoreTableContext;
